<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large" style="height: 80%">
      <header class="modal-card-head">
        <p class="modal-card-title header">Boleto {{ invoice.customer }} #{{ invoice.boleto_invoice }}</p>
      </header>
      <section class="modal-card-body">
        <p class="title" v-if="invoice.boleto_banco && invoice.boleto_banco === 1"><b>BRADESCO</b></p>
        <p class="title" v-if="invoice.boleto_banco && invoice.boleto_banco === 2"><b>SANTANDER</b></p>
        <p class="title" v-if="invoice.boleto_banco && invoice.boleto_banco === 3"><b>ITAU</b></p>
        <div class="container">
          <div>
            <p class="label">Numero Boleto</p>
            <p class="item" v-if="invoice.boleto_numero">{{ invoice.boleto_numero }}</p>
            <p class="item" v-else>ERRO NA EMISSÃO</p>
          </div>
          <div>
            <p class="label">Vencimento</p>
            <p class="item" v-if="invoice.boleto_vencimento">{{ new Date(invoice.boleto_vencimento).toLocaleDateString("pt-br") }}</p>
            <p class="item" v-else>ERRO NA EMISSÃO</p>
          </div>
          <div>
            <p class="label">Status de envio</p>
            <p class="item" v-if="invoice.boleto_enviado && invoice.boleto_enviado === 1">ENVIADO</p>
            <p class="item" v-else>NÃO ENVIADO</p>
          </div>
        </div>
        <div class="container">
          <div>
            <p class="label">Situação</p>
            <p class="item" v-if="invoice.boleto_situacao === 0">EMITIDO</p>
            <p class="item" v-if="invoice.boleto_situacao && invoice.boleto_situacao === 1">PAGO</p>
            <p class="item" v-if="invoice.boleto_situacao && invoice.boleto_situacao === 2">ESTORNADO</p>
            <p class="item" v-if="invoice.boleto_situacao && invoice.boleto_situacao === 3">ERRO NA EMISSÃO</p>
          </div>
          <div>
            <p class="label">Data do pagamento</p>
            <p class="item" v-if="invoice.boleto_pagamento">{{ new Date(invoice.boleto_pagamento).toLocaleDateString("pt-br") }}</p>
            <p class="item" v-else>NÃO PAGO</p>
          </div>
          <div>
            <p class="label">Valor</p>
            <p class="item" v-if="invoice.boleto_valor">{{ Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(invoice.boleto_valor) }}</p>
            <p class="item" v-else>ERRO NA EMISSÃO</p>
          </div>
        </div>
        <div class="container" v-if="invoice.boleto_linha_digitavel">
          <div>
            <p class="label">Linha Digitavel</p>
            <p class="item" style="width: 100%">{{ invoice.boleto_linha_digitavel }}</p>
          </div>
        </div>
        <div class="container" v-if="invoice.boleto_mensagem">
          <div>
            <p class="label">Mensagem</p>
            <p class="item" style="width: 100%">{{ invoice.boleto_mensagem }}</p>
          </div>
        </div>
        <div class="container" v-if="invoice.boleto_situacao !== 3">
          <div>
            <button
              class="button is-info"
              @click="downloadBoleto()"
              style="margin-top: 2rem">
              Download Boleto
            </button>
            <button
              class="button is-success"
              v-if="invoice.boleto_situacao !== 1"
              @click="updateBoleto()"
              style="margin-top: 2rem">
              Consistir Boleto
            </button>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a class="button is-primary" @click="close(true)">Cancel</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  import babelPolyfill from 'babel-polyfill'
  import vSelect from 'vue-select'
  import message from '../../../../utils/message'
  import 'vue-select/dist/vue-select.css'
  export default {
    props: {
      context: {
        type: Object
      },
      invoice: {
        type: Object,
        required: true
      },
      callback: {
        type: String
      }
    },
    data () {
      return {
        data: {
          agency: '',
          invoice: '',
          amount: '',
          currency: ''
        }
      }
    },
    mounted () {
      this.$nextTick(() => {
        document.body.appendChild(this.$el)
      })
    },
    methods: {
      updateBoleto () {
        console.log('Updating...')
        this.data = {
          invoice: this.invoice.id,
          banco: this.invoice.boleto_banco
        }
        this.context.$http.post(this.context.$store.state.config.apiURL + '/V2/invoice/update_boleto', this.data).then((response) => {
          this.message('success', 'Success', response.body)
          this.close(true, 'ok')
        }, (response) => {
          this.message('danger', 'Error', response.body.message)
          this.close(true, 'ok')
        })
      },
      downloadBoleto () {
        window.location.href = this.context.$store.state.config.apiURL + '/V2/invoice/download_boleto/' + this.invoice.id
      },
      close (closeOnly, result) {
        if (!closeOnly) {
          this.context[this.callback](result)
        }
        this.$el.remove()
      },
      message (type, title, content, duration = 4500) {
        let propsData = {
          title: title,
          message: content,
          type: type,
          direction: 'down',
          duration: duration,
          showCloseButton: true
        }
        message.openMessage(propsData)
      }
    },
    components: {
      babelPolyfill,
      vSelect
    }
  }
</script>
<style scoped>
  .title {
    text-align: center;
    margin-bottom: 2rem;
  }
  .container {
    padding: 0;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
  }

  .label {
    text-align: center;
  }
  .item {
    text-align: center;
    background-color: white;
    box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
    color: #4a4a4a;
    padding: 0.3rem;
    margin: 0.5rem;
    width: 150px;
  }

  .header {
    font-size: 16px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// Boleto.vue?106fb9f6